import request from "@/utils/request";

export function getInvoiceById(id)
{
    return request({
        url: "/invoices/" + id,
        method: "get",
        showLoader: true
    });
}
